import { createContext, useContext } from "react";
import { Bounce, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface ToastContextProps {
    notifySuccess(content: string): void;

    notifyError(content: string): void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

interface ToastProviderProps {
    children: React.ReactNode;
}

export function ToastProvider({
    children
}: ToastProviderProps): React.ReactElement {
    const notifySuccess = (content: string) =>
        toast.success(content, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            style: {
                fontFamily: '"IBM Plex Sans", sans-serif',
                fontSize: "16px",
                lineHeight: "22px"
            }
        });
    const notifyError = (content: string) =>
        toast.error(content, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            style: {
                fontFamily: '"IBM Plex Sans", sans-serif',
                fontSize: "16px",
                lineHeight: "22px"
            }
        });

    return (
        <ToastContext.Provider value={{ notifySuccess, notifyError }}>
            {children}
            <ToastContainer />
        </ToastContext.Provider>
    );
}

export function useToastContext(): ToastContextProps {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error("useToastContext must be used within a ToastProvider");
    }
    return context;
}
